import { MenuConfig, MenuItem } from '@/config/types';

/**
 * Filter menu items based on enabled modules
 */
export function filterMenuByModules(
  menu: MenuConfig,
  enabledModules: string[]
): MenuConfig {
  return menu.map(section => ({
    ...section,
    children: section.children ? filterMenuItems(section.children, enabledModules) : undefined,
  })).filter(section => section.children && section.children.length > 0);
}

function filterMenuItems(
  items: MenuItem[],
  enabledModules: string[]
): MenuItem[] {
  return items
    .filter(item => {
      // If no module required, always show
      if (!item.requiredModule) {
        return true;
      }
      // Check if required module is enabled
      return enabledModules.includes(item.requiredModule);
    })
    .map(item => {
      // Recursively filter children if they exist
      if (item.children) {
        return {
          ...item,
          children: filterMenuItems(item.children, enabledModules),
        };
      }
      return item;
    });
}

/**
 * D15-23 — drops items (at any depth) whose `requiredPermission` is set and
 * not held. UX-only: hiding a link is never an access control.
 */
export function filterMenuByPermission(
  menu: MenuConfig,
  permissions: readonly string[] | undefined,
): MenuConfig {
  return menu
    .filter((item) => !item.requiredPermission || (permissions?.includes(item.requiredPermission) ?? false))
    .map((item) =>
      item.children
        ? { ...item, children: filterMenuByPermission(item.children, permissions) }
        : item,
    );
}
